import { storyblokEditable, StoryblokRichText  } from "@storyblok/react";


const ArticleSection = ({ blok }) => {
    console.log(blok);
  return (  
    <div {...storyblokEditable(blok)} className="font-display">
      <div className="article-section-wrap">
          <div className="article-section-title-wrap">
            <h4 className="article-title">{blok.sectiontitle}</h4>
          </div>
          <div className="article-section-content-wrap">
            <StoryblokRichText doc={blok.sectioncontent}/>
            {/* <div dangerouslySetInnerHTML={{ __html: renderRichText(blok.sectioncontent) }} /> */}
            {blok.video}
          </div>
      </div>
    </div>
  );
};

export default ArticleSection;